import React from 'react';
import classNames from 'classnames';
import { Button, CUIText, Icon, IconNames } from '@dotcom/crown-ui';
import { FontSizeAction, FontSizeProps } from '../font-drawer-types';
import styles from '../font-drawer.module.scss';
import { useTranslation } from 'react-i18next';

export const FontSize = ({
  addClass = '',
  label,
  onClickButton,
  fontSizeValue,
  upper,
  lower,
  testId = 'font-size',
}: FontSizeProps): React.ReactElement => {
  const classes = classNames(styles['font-size'], addClass);
  const { t } = useTranslation();

  const shouldDisabledRemoveButton = fontSizeValue === lower;
  const shouldDisabledAddButton = fontSizeValue === upper;

  return (
    <section className={classes} data-testid={testId}>
      <CUIText as="label" variant="form">
        {label}
      </CUIText>
      <div className={styles.counter}>
        <Button
          testId="decreaseFontButton"
          aria-label={t('fontDrawer.decreaseFontSize') as string}
          disabled={shouldDisabledRemoveButton}
          variant="secondary"
          size="icon"
          onClick={() => onClickButton(FontSizeAction.Decrease)}
        >
          <Icon name={IconNames.Remove} />
        </Button>
        <CUIText as="span" color="textPrimary" className={styles['counterValue']}>
          {fontSizeValue}
        </CUIText>
        <Button
          testId="increaseFontButton"
          aria-label={t('fontDrawer.increaseFontSize') as string}
          disabled={shouldDisabledAddButton}
          variant="secondary"
          size="icon"
          onClick={() => onClickButton(FontSizeAction.Increase)}
        >
          <Icon name={IconNames.Expand} />
        </Button>
      </div>
    </section>
  );
};
